import React from 'react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

const menuItems = [
  { label: 'WORK', path: '/work' },
  { label: 'ABOUT', path: '/about' },
  { label: 'CONTACT', path: '/contact' },
];

const socialLinks = [
  { label: 'Instagram', url: 'https://www.instagram.com/laloxsolorio', icon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="32" height="32" rx="8" stroke="white" strokeWidth="3"/>
      <circle cx="20" cy="20" r="10" stroke="white" strokeWidth="3"/>
      <circle cx="29" cy="13" r="2.5" fill="white"/>
    </svg>
  ) },
  { label: 'Facebook', url: 'https://www.facebook.com', icon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="32" height="32" rx="8" stroke="white" strokeWidth="3"/>
      <path d="M25 14h-4a2 2 0 0 0-2 2v4h6l-1 5h-5v10" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ) },
  { label: 'Twitter', url: 'https://www.twitter.com', icon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="32" height="32" rx="8" stroke="white" strokeWidth="3"/>
      <path d="M13 27c12 0 18-10 18-18v-1A13 13 0 0 0 36 7a13 13 0 0 1-3.1.8A6.5 6.5 0 0 0 34.1 5c-1.3.7-2.7 1.1-4.2 1.4A6.5 6.5 0 0 0 20 4c-3.6 0-6.5 2.9-6.5 6.5 0 .5.1 1 .2 1.5A18.6 18.6 0 0 1 4 6.3a6.5 6.5 0 0 0 2 8.7A6.5 6.5 0 0 1 3.6 14v.1c0 3.1 2.2 5.7 5.2 6.3a6.5 6.5 0 0 1-2.9.1c.8 2.6 3.2 4.5 6 4.6A13.1 13.1 0 0 1 4 33.1 18.6 18.6 0 0 0 13 36c15.1 0 23.3-12.5 23.3-23.3 0-.4 0-.7-.1-1.1A16.4 16.4 0 0 0 40 9.9" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ) },
];

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.leftMenu}>
        {menuItems.map((item) => (
          <Link key={item.label} to={item.path} className={styles.menuItem}>{item.label}</Link>
        ))}
      </div>
      <div className={styles.centerCopyright}>
        &copy; {new Date().getFullYear()} Lalo Solorio. All rights reserved.
      </div>
      <div className={styles.rightSocials}>
        {socialLinks.map((link) => (
          <a key={link.label} href={link.url} className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label={link.label}>
            {link.icon}
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
